angular.module('app.myHockeyTv.manageReminders.reminderFrequencyListService', [])
  .factory('app.myHockeyTv.manageReminders.reminderFrequencyListService', [
    '$http',
    function ($http) {
      let frequencies = {
        list: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('reminders_frequencies'))
            .then(
              /**
               * @param {HttpResponse} response
               */
              (response) => {
                let data = response.data;
                if (data.results) {
                  frequencies.list = data.results;
                }
                if (data.error) {
                  return frequencies.error = data.error;
                }
              },
              /**
               * @param {HttpResponse} response
               */
              (response) => {
                let data = response.data;
                if (data.error) {
                  return frequencies.error = data.error;
                }
              }
            );
        }
      };
      return frequencies;
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/manageReminders/reminderFrequencyListService.js